//  此处颜色与css中的变量拉齐，
//  todo: '后续整合到Itachi的全局配置下，避免业务开发直接使用config判断颜'

export const defaultColor = {
  rise: '#00c087',
  'rise-1': 'rgba(0, 192, 135, 0.1)',
  fall: '#f34a68',
  'fall-1': 'rgba(243, 74, 104, 0.1)',
  r1: '#f34a68',
  r2: 'rgba(243, 74, 104, 0.8)',
  r3: 'rgba(243, 74, 104, 0.2)',
  g1: '#00c087',
  g2: 'rgba(0, 192, 135, 0.8)',
  g3: 'rgba(0, 192, 135, 0.2)',
  o1: '#557bfa',
  o2: 'rgba(85, 123, 250, 0.8)',
  o3: 'rgba(85, 123, 250, 0.1)',
  c1: '#a7c4ff',
  c2: 'rgba(167, 196, 255, 0.8)',
  c3: 'rgba(167, 196, 255, 0.1)',
  // W1-背景色
  1: '#ffffff',
  // W2-背景色
  2: '#f7f9fa',
  // W3-悬浮色/辅助背景色
  3: '#f5f6f7',
  // W4-分割线用色
  4: '#eeeeee',
  // W5-常用于禁用按钮
  5: '#eaeaea',
  // W6-主题色
  6: '#222222',
  // W7-一级文字色/标题、重要正文内容
  7: '#262626',
  // W8-二级文字色/次要文字
  8: '#999999',
  // W9-提示文字色/辅助说明内容
  9: '#b6b6b6',
  // W10-文字/背景色/线框色
  10: '#dbdbdb',
  // W11-文字色（常用于渐变色/蒙层上的文字）
  11: '#fefefe',
  // W12-可链接文字色
  12: '#557bfa',
  // W13-警示色/提醒色
  13: '#fb8c40',
  // W14-(暂未使用)
  14: '#f5faff',
  // W15-表头用色
  15: '#f5f8ff',
  // W16-文字色
  16: '#666666',
  // W17-辅助背景色（如：FAQ）
  17: '#fafafa',
  // W18-运营文字色
  18: '#33479a',
  // W19-辅助背景色(暂定)
  19: '#eaeff9',
  // W20-导航栏+底部栏背景色
  20: '#ffffff',
  // W21-常用于图标
  21: '#5f94ff',
  // W22-选项按钮、输入框、搜索框
  22: '#f6f6f6',
  // W23-仅用于弹窗
  23: '#fffefe',
}

export const darkColor = {
  r1: '#f34a68',
  r2: 'rgba(243, 74, 104, 0.8)',
  r3: 'rgba(243, 74, 104, 0.2)',
  g1: '#00c087',
  g2: 'rgba(0, 192, 135, 0.8)',
  g3: 'rgba(0, 192, 135, 0.2)',
  o1: '#557bfa',
  o2: 'rgba(85, 123, 250, 0.8)',
  o3: 'rgba(85, 123, 250, 0.1)',
  c1: '#a7c4ff',
  c2: 'rgba(167, 196, 255, 0.8)',
  c3: 'rgba(167, 196, 255, 0.1)',
  // B1-背景色
  1: '#232b38',
  // B2-背景色
  2: '#1d1d1e',
  // B3-悬浮色/辅助背景色
  3: '#1b1d21',
  // B4-分割线用色
  4: '#212324',
  // B5-常用于禁用按钮色
  5: '#262728',
  // B6-主题色
  6: '#fefefe',
  // B7-一级文字色/标题、重要正文内容
  7: '#e7e7e7',
  // B8-二级文字色/次要文字
  8: '#999999',
  // B9-提示文字色/辅助说明内容
  9: '#5f5f5f',
  // B10-文字色/背景色/线框色
  10: '#4a4a4a',
  // B11-文字色（常用于渐变色上）
  11: '#ffffff',
  // B12-可链接文字色
  12: '#819cff',
  // B3-警示色/提醒色
  13: '#fb8c40',
  // B14-（暂未使用）
  14: '#29292b',
  // B15-表头用色
  15: '#202226',
  // B16-文字色
  16: '#bfbfbf',
  // B17-辅助背景色（如：FAQ）
  17: '#18191a',
  // B18-运营文字色
  18: '#acc3ff',
  // B19-辅助背景色(暂定)
  19: '#1a1b1c',
  // B20-导航栏+底部栏背景色
  20: '#000000',
  // B21-常用于图标
  21: '#5f94ff',
  // B22-选项按钮、输入框、搜索框
  22: '#1d1e1f',
  // B23-仅用于弹窗
  23: '#181818',
}

export const trendReverseColor = {
  rise: '#f34a68',
  'rise-1': 'rgba(243, 74, 104, 0.1)',
  fall: '#00c087',
  'fall-1': 'rgba(0, 192, 135, 0.1)',
}
